export enum SortingOrder {
  LastModified = 0,
  Alphabetical = 1
}
